const auth = localStorage.getItem("cmyuva-supplier");

const initialState = {
    auth: auth ? JSON.parse(auth) : {},
    isAuthenticated: auth ? Object.keys(auth).length ? true : false : false,
    loading: false,
    errors: {},
    otpLoading: false,
    sendOtp: "",
    resendOtp: false,
    otpVerifiedStatus: false,
    verifyOtp: "",
    verifyOtploading: false,
    ChangePasswordloading: false,
    changedPasswordStatus:[],
    enquiryStatus:[],

};

const AuthReducer = (state = initialState, action) => {
    switch (action.type) {
        case "LOGIN_PENDING":
            return { ...state, loading: true };
        
        case "LOGIN_FULFILLED":
            return { ...state, loading: false, auth: action.payload, isAuthenticated: true };
        
        case "LOGIN_FAILED":
            return { ...state, loading: false, errors: action.payload };
        
        case "SEND_OTP":
            return { ...state, otpLoading: true, errors: {} };
        
        case "SEND_OTP_FULFILLED":
            return { ...state, otpLoading: false };
        
        case "SEND_OTP_REJECTED":
            return { ...state, errors: action?.payload, otpLoading: false };
        
        case "RESEND_OTP":
            return { ...state, resendOtp: false, otpLoading: true, errors: {} };
        
        case "RESEND_OTP_FULFILLED":
            return { ...state, resendOtp: true, otpLoading: false };
        
        case "RESEND_OTP_REJECTED":
            return { ...state, errors: action.payload.data, otpLoading: false };
        
        case "VERIFY_OTP":
            return { ...state, verifyOtploading: true, errors: {}, otpVerifiedStatus: false };
        
        case "VERIFY_OTP_FULFILLED":
            return { ...state, verifyOtp: action.data, verifyOtploading: false, otpVerifiedStatus: true };
        
        case "VERIFY_OTP_REJECTED":
            if (action.payload.status === 422) {
                return {
                    ...state,
                    errors: action.payload.data.errors,
                    verifyOtploading: false,
                    otpVerifiedStatus: false,
                };
            } else {
                return {
                    ...state,
                    errors: action.payload.data,
                    verifyOtploading: false,
                    otpVerifiedStatus: false,
                };
            }
        case "CHANGE_PASSWORD":
            return { ...state, ChangePasswordloading: true, errors: {} };
        
        case "CHANGE_PASSWORD_FULFILLED":
            return { ...state, changedPasswordStatus: action.payload, ChangePasswordloading: false };
        
        case "CHANGE_PASSWORD_REJECTED":
            if (action.payload.status === 422) {
                return {
                    ...state,
                    errors: action.payload.data.errors,
                    ChangePasswordloading: false,
                };
            } else {
                return {
                    ...state,
                    errors: action.payload.data,
                    ChangePasswordloading: false,
                };
            }
        case "SUBMIT_ENQUIRY_PENDING":
            return { ...state, submitEnquiryLoading: true, errors: {} };
        
        case "SUBMIT_ENQUIRY_FULFILLED":
            return { ...state, submitEnquiryLoading: false , enquiryStatus: action.payload};
        
        case "SUBMIT_ENQUIRY_REJECTED":
            return { ...state, errors: action?.payload, submitEnquiryLoading: false };

        case "LOG_OUT_FULFILLED":
            return { ...state, auth: {}, isAuthenticated: false };
        
        case "RESET_DEFAULT":
            return { ...state,  changedPasswordStatus: false ,enquiryStatus:false,otpVerifiedStatus:false};
        
        default:
            return state;
    }
};

export default AuthReducer;
